const GEOFENCING_SUPPORTED_COUNTRIES = {
  AE: 'AE',
  AT: 'AT',
  AU: 'AU',
  BE: 'BE',
  BG: 'BG',
  CA: 'CA',
  CH: 'CH',
  CN: 'CN',
  CZ: 'CZ',
  DE: 'DE',
  DK: 'DK',
  EE: 'EE',
  ES: 'ES',
  FI: 'FI',
  FR: 'FR',
  GB: 'GB',
  GR: 'GR',
  HR: 'HR',
  HU: 'HU',
  IE: 'IE',
  IS: 'IS',
  IT: 'IT',
  JP: 'JP',
  KR: 'KR',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  NL: 'NL',
  NO: 'NO',
  NZ: 'NZ',
  PL: 'PL',
  PT: 'PT',
  RO: 'RO',
  SE: 'SE',
  SI: 'SI',
  SK: 'SK',
  US: 'US',
};

const GEOFENCING_SHOP_IDS = {
  AE: 'AE',
  AU: 'AU',
  BE: 'BE',
  CA: 'CA',
  CN: 'CN',
  DK: 'DK',
  EE: 'EE',
  EU: 'EU',
  FI: 'FI',
  GB: 'UK',
  IE: 'IE',
  IS: 'IS',
  JP: 'JP',
  KR: 'KR',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  NL: 'NL',
  NO: 'NO',
  NZ: 'NZ',
  SE: 'SE',
  UK: 'UK',
  US: 'US',
};

const GEOFENCING_SHOPS = {
  [GEOFENCING_SHOP_IDS.AE]: {
    id: GEOFENCING_SHOP_IDS.AE,
    name: 'United Arab Emirates',
    url: 'https://www.allbirds.ae',
  },
  [GEOFENCING_SHOP_IDS.AU]: {
    id: GEOFENCING_SHOP_IDS.AU,
    name: 'Australia',
    url: 'https://www.allbirds.com.au',
  },
  [GEOFENCING_SHOP_IDS.BE]: {
    id: GEOFENCING_SHOP_IDS.BE,
    name: 'Belgium',
    url: 'https://www.allbirdsbenelux.nl',
  },
  [GEOFENCING_SHOP_IDS.CA]: {
    id: GEOFENCING_SHOP_IDS.CA,
    name: 'Canada',
    url: 'https://www.allbirds.ca',
  },
  [GEOFENCING_SHOP_IDS.CN]: {
    id: GEOFENCING_SHOP_IDS.CN,
    name: 'China',
    url: 'https://www.allbirds.cn',
  },
  [GEOFENCING_SHOP_IDS.DK]: {
    id: GEOFENCING_SHOP_IDS.DK,
    name: 'Denmark',
    url: 'https://www.allbirds.dk',
  },
  [GEOFENCING_SHOP_IDS.EE]: {
    id: GEOFENCING_SHOP_IDS.EE,
    name: 'Estonia',
    url: 'https://www.allbirds.ee',
  },
  [GEOFENCING_SHOP_IDS.EU]: {
    id: GEOFENCING_SHOP_IDS.EU,
    name: 'Europe',
    url: 'https://www.allbirds.eu',
  },
  [GEOFENCING_SHOP_IDS.FI]: {
    id: GEOFENCING_SHOP_IDS.FI,
    name: 'Finland',
    url: 'https://www.allbirdsfinland.fi',
  },
  [GEOFENCING_SHOP_IDS.IE]: {
    id: GEOFENCING_SHOP_IDS.IE,
    name: 'Ireland',
    url: 'https://www.allbirdsbenelux.nl/en',
  },
  [GEOFENCING_SHOP_IDS.IS]: {
    id: GEOFENCING_SHOP_IDS.IS,
    name: 'Iceland',
    url: 'https://www.allbirds.is',
  },
  [GEOFENCING_SHOP_IDS.JP]: {
    id: GEOFENCING_SHOP_IDS.JP,
    name: 'Japan',
    url: 'https://www.allbirds.jp',
  },
  [GEOFENCING_SHOP_IDS.KR]: {
    id: GEOFENCING_SHOP_IDS.KR,
    name: 'South Korea',
    url: 'https://www.allbirds.co.kr',
  },
  [GEOFENCING_SHOP_IDS.LT]: {
    id: GEOFENCING_SHOP_IDS.LT,
    name: 'Lithuania',
    url: 'https://www.allbirds.lt',
  },
  [GEOFENCING_SHOP_IDS.LU]: {
    id: GEOFENCING_SHOP_IDS.LU,
    name: 'Luxembourg',
    url: 'https://www.allbirdsbenelux.nl',
  },
  [GEOFENCING_SHOP_IDS.LV]: {
    id: GEOFENCING_SHOP_IDS.LV,
    name: 'Latvia',
    url: 'https://www.allbirds.lv',
  },
  [GEOFENCING_SHOP_IDS.NL]: {
    id: GEOFENCING_SHOP_IDS.NL,
    name: 'Netherlands',
    url: 'https://www.allbirdsbenelux.nl',
  },
  [GEOFENCING_SHOP_IDS.NO]: {
    id: GEOFENCING_SHOP_IDS.NO,
    name: 'Norway',
    url: 'https://www.allbirds.no',
  },
  [GEOFENCING_SHOP_IDS.NZ]: {
    id: GEOFENCING_SHOP_IDS.NZ,
    name: 'New Zealand',
    url: 'https://www.allbirds.co.nz',
  },
  [GEOFENCING_SHOP_IDS.SE]: {
    id: GEOFENCING_SHOP_IDS.SE,
    name: 'Sweden',
    url: 'https://www.allbirdssweden.se',
  },
  [GEOFENCING_SHOP_IDS.UK]: {
    id: GEOFENCING_SHOP_IDS.UK,
    name: 'United Kingdom',
    url: 'https://www.allbirds.co.uk',
  },
  [GEOFENCING_SHOP_IDS.US]: {
    id: GEOFENCING_SHOP_IDS.US,
    name: 'United States',
    url: 'https://www.allbirds.com',
  },
};

const GEOFENCING_SHOP_TO_COUNTRY_SUPPORT_MAP = {
  [GEOFENCING_SHOP_IDS.AE]: [GEOFENCING_SUPPORTED_COUNTRIES.AE],
  [GEOFENCING_SHOP_IDS.AU]: [GEOFENCING_SUPPORTED_COUNTRIES.AU],
  [GEOFENCING_SHOP_IDS.BE]: [GEOFENCING_SUPPORTED_COUNTRIES.BE],
  [GEOFENCING_SHOP_IDS.CA]: [GEOFENCING_SUPPORTED_COUNTRIES.CA],
  [GEOFENCING_SHOP_IDS.CN]: [GEOFENCING_SUPPORTED_COUNTRIES.CN],
  [GEOFENCING_SHOP_IDS.DK]: [GEOFENCING_SUPPORTED_COUNTRIES.DK],
  [GEOFENCING_SHOP_IDS.EE]: [GEOFENCING_SUPPORTED_COUNTRIES.EE],
  [GEOFENCING_SHOP_IDS.EU]: [
    GEOFENCING_SUPPORTED_COUNTRIES.AT,
    GEOFENCING_SUPPORTED_COUNTRIES.BG,
    GEOFENCING_SUPPORTED_COUNTRIES.CH,
    GEOFENCING_SUPPORTED_COUNTRIES.CZ,
    GEOFENCING_SUPPORTED_COUNTRIES.DE,
    GEOFENCING_SUPPORTED_COUNTRIES.ES,
    GEOFENCING_SUPPORTED_COUNTRIES.FR,
    GEOFENCING_SUPPORTED_COUNTRIES.GR,
    GEOFENCING_SUPPORTED_COUNTRIES.HR,
    GEOFENCING_SUPPORTED_COUNTRIES.HU,
    GEOFENCING_SUPPORTED_COUNTRIES.IT,
    GEOFENCING_SUPPORTED_COUNTRIES.PL,
    GEOFENCING_SUPPORTED_COUNTRIES.PT,
    GEOFENCING_SUPPORTED_COUNTRIES.RO,
    GEOFENCING_SUPPORTED_COUNTRIES.SI,
    GEOFENCING_SUPPORTED_COUNTRIES.SK,
  ],
  [GEOFENCING_SHOP_IDS.FI]: [GEOFENCING_SUPPORTED_COUNTRIES.FI],
  [GEOFENCING_SHOP_IDS.IE]: [GEOFENCING_SUPPORTED_COUNTRIES.IE],
  [GEOFENCING_SHOP_IDS.IS]: [GEOFENCING_SUPPORTED_COUNTRIES.IS],
  [GEOFENCING_SHOP_IDS.JP]: [GEOFENCING_SUPPORTED_COUNTRIES.JP],
  [GEOFENCING_SHOP_IDS.KR]: [GEOFENCING_SUPPORTED_COUNTRIES.KR],
  [GEOFENCING_SHOP_IDS.LT]: [GEOFENCING_SUPPORTED_COUNTRIES.LT],
  [GEOFENCING_SHOP_IDS.LU]: [GEOFENCING_SUPPORTED_COUNTRIES.LU],
  [GEOFENCING_SHOP_IDS.LV]: [GEOFENCING_SUPPORTED_COUNTRIES.LV],
  [GEOFENCING_SHOP_IDS.NL]: [GEOFENCING_SUPPORTED_COUNTRIES.NL],
  [GEOFENCING_SHOP_IDS.NO]: [GEOFENCING_SUPPORTED_COUNTRIES.NO],
  [GEOFENCING_SHOP_IDS.NZ]: [GEOFENCING_SUPPORTED_COUNTRIES.NZ],
  [GEOFENCING_SHOP_IDS.SE]: [GEOFENCING_SUPPORTED_COUNTRIES.SE],
  [GEOFENCING_SHOP_IDS.UK]: [GEOFENCING_SUPPORTED_COUNTRIES.GB],
  [GEOFENCING_SHOP_IDS.US]: [GEOFENCING_SUPPORTED_COUNTRIES.US],
};

const GEOFENCING_COUNTRY_TO_SHOP_SUPPORT_MAP = Object.entries(
  GEOFENCING_SHOP_TO_COUNTRY_SUPPORT_MAP,
).reduce((acc, [shopID, countries]) => {
  countries.forEach((country) => {
    acc[country] = acc[country] || [];
    acc[country].push(shopID);
  });
  return acc;
}, {});

export {
  GEOFENCING_COUNTRY_TO_SHOP_SUPPORT_MAP,
  GEOFENCING_SHOP_IDS,
  GEOFENCING_SHOP_TO_COUNTRY_SUPPORT_MAP,
  GEOFENCING_SHOPS,
  GEOFENCING_SUPPORTED_COUNTRIES,
};
